// extracted by mini-css-extract-plugin
export var legendIndicator = "_cm-1";
export var legendRight = "_cm-0";